import { useQuery } from '@tanstack/react-query'
import { getCloseReasons } from '@/lib'
import { queryKeys } from '@/lib/queryKeys'

interface UseCloseReasonsOptions {
  enabled?: boolean
}

/**
 * クローズ理由一覧を取得するカスタムフック
 */
export function useCloseReasons(options: UseCloseReasonsOptions = {}) {
  const { enabled = true } = options

  return useQuery({
    queryKey: queryKeys.closeReasons,
    queryFn: () => getCloseReasons(),
    enabled,
    staleTime: 1000 * 60 * 60, // 1時間キャッシュ（マスターデータのため）
  })
}
